import { apiClient } from '../../config/axios.config';
import { BASE_TRAVEL_REQUEST_URL, BASE_URL } from '../apiConfig';

export const saveTravelRequestDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/save-travel-request`,
    payload,
  );
  return response;
};

export const fetchTravelRequestDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/travel-request-details`,
    payload,
  );
  return response;
};

export const fetchTravelRequestOptions = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/travel-request-options`,
    payload,
  );
  return response;
};

export const fetchPODetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/po-details`,
    payload,
  );
  return response;
};

export const fetchAllRevisions = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/all-revisions`,
    payload,
  );
  return response;
};

export const fetchApproverDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/approver-details`,
    payload,
  );
  return response;
};

export const fetchClone = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/clone`,
    payload,
  );
  return response;
};

export const fetchDefault = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/default`,
    payload,
  );
  return response;
};

export const uploadDocument = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/upload-document`,
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response;
};

export const deleteDocument = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_TRAVEL_REQUEST_URL}/delete-document`,
    payload,
  );
  return response;
};
